import React, { Component, Suspense } from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';

export function withSuspense(message, WrappedComponent) {
  class WithSuspense extends Component {
    render() {
      return (
      <Suspense fallback={message}>
        <WrappedComponent {...this.props} />
      </Suspense>
      );
    }
  }
  hoistNonReactStatic(WithSuspense, WrappedComponent);
  return WithSuspense;
}
